import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser
  }),
  ...mapGetters('auth', ['loggedIn'])
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutScrollable: (state) => state.layoutScrollable,
    loader: (state) => state.loader,
    browserMode: (state) => state.browserMode
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLoaderValue', 'changeLayoutPosition', 'changeBrowserMode'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
